<template><div class="message-container"><slot></slot></div></template>
<script>
    export default {
        name: "MessageContainer"
    }
</script>
<style scoped>
.message-container{
    display: flex;
    overflow: hidden;
    position: relative;
    padding: 0;
    margin: 0;
    width: 100%;
    height: 100%;
    background: #FFFFFF;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/Messages/components/MessageContainer.vue"
}
</vue-filename-injector>
